<template>
  <div class="search-sidebar--single">
    <h3 class="filter--title">{{ $t('general.filter.listingType') }}</h3>
    <div class="d-flex">
      <button
        type="button"
        class="btn btn-primary--outline px-4 mr-2"
        :class="{ 'btn-primary': type === 'S' }"
        style="min-width: 120px"
        @click="type = 'S'"
      >
        <span style="position: relative">
          {{ $t('general.sell') }}
        </span>
      </button>
      <button
        type="button"
        class="btn btn-primary--outline px-4"
        :class="{ 'btn-primary': type === 'R' }"
        style="min-width: 120px"
        @click="type = 'R'"
      >
        {{ $t('general.R') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SearchMixin from '@/mixins/searchMixin';

export default {
  mixins: [SearchMixin],
  computed: {
    ...mapState({
      isLoading: (state) => state.v2.search.isLoading,
    }),
    type: {
      get() {
        return this.$store.state.v2.search.type;
      },
      set(value) {
        this.$store.commit('v2/search/SET_TYPE', value);

        // APPLY FILTER ON SELECT LISTING TYPE
        if (this.$mq !== 'xs') {
          this.$store.dispatch('v2/search/goToSearchPage', {
            router: this.$router,
            params: this.$route.params,
          });
        }
      },
    },
  },
  data: () => ({}),
  methods: {},
};
</script>
